const IconGift = ({ color }) => {
  return (
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.5 11.333C3.5 10.3902 3.5 9.91879 3.79289 9.6259C4.08579 9.33301 4.55719 9.33301 5.5 9.33301H22.5C23.4428 9.33301 23.9142 9.33301 24.2071 9.6259C24.5 9.91879 24.5 10.3902 24.5 11.333V13.4163C24.5 14.1186 24.5 14.4697 24.3315 14.7219C24.2585 14.8311 24.1648 14.9249 24.0556 14.9978C23.8033 15.1663 23.4522 15.1663 22.75 15.1663V15.1663C22.0478 15.1663 21.6967 15.1663 21.4444 15.3349C21.3352 15.4078 21.2415 15.5016 21.1685 15.6108C21 15.863 21 16.2141 21 16.9163V21.333C21 22.2758 21 22.7472 20.7071 23.0401C20.4142 23.333 19.9428 23.333 19 23.333H9C8.05719 23.333 7.58579 23.333 7.29289 23.0401C7 22.7472 7 22.2758 7 21.333V16.9163C7 16.2141 7 15.863 6.83147 15.6108C6.75851 15.5016 6.66476 15.4078 6.55557 15.3349C6.30335 15.1663 5.95223 15.1663 5.25 15.1663V15.1663C4.54777 15.1663 4.19665 15.1663 3.94443 14.9978C3.83524 14.9249 3.74149 14.8311 3.66853 14.7219C3.5 14.4697 3.5 14.1186 3.5 13.4163V11.333Z"
        stroke={color}
        strokeWidth="2"
      />
      <path d="M5.83301 15.167H22.1663" stroke={color} strokeWidth="2" strokeLinecap="round" />
      <path d="M14 8.16699L14 23.3337" stroke={color} strokeWidth="2" strokeLinecap="round" />
      <path
        d="M13.9997 8.16667L12.9192 7.08618C11.7117 5.87866 10.2396 4.96886 8.61952 4.42884L8.46546 4.37749C7.1704 3.9458 5.83301 4.90974 5.83301 6.27485V6.72515C5.83301 7.58601 6.38387 8.35029 7.20055 8.62252L9.33301 9.33333"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M14.0003 8.16667L15.0808 7.08618C16.2883 5.87866 17.7604 4.96886 19.3805 4.42884L19.5345 4.37749C20.8296 3.9458 22.167 4.90974 22.167 6.27485V6.72515C22.167 7.58601 21.6161 8.35029 20.7994 8.62252L18.667 9.33333"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  )
}

export default IconGift
